const BACKGROUND_COLOR_STYLE_ELEMENT_ID = 'style-store-background-color';

function isValidCssColor(cssColor: string): boolean {
  return CSS.supports('color', cssColor);
}

function getTextColor(backgroundColor: string): string {
  let normalizedHex = backgroundColor.replace(/^#/, '');
  if (normalizedHex.length === 3) {
    normalizedHex =
      normalizedHex[0] +
      normalizedHex[0] +
      normalizedHex[1] +
      normalizedHex[1] +
      normalizedHex[2] +
      normalizedHex[2];
  }
  const red = parseInt(normalizedHex.substring(0, 2), 16);
  const green = parseInt(normalizedHex.substring(2, 4), 16);
  const blue = parseInt(normalizedHex.substring(4, 6), 16);

  if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
    return '#4B4B55';
  }
  return '#EBEBF0';
}

export function applyBackgroundColor(backgroundColor: string): boolean {
  if (document.getElementById(BACKGROUND_COLOR_STYLE_ELEMENT_ID)) {
    // Color already loaded
    return true;
  }

  if (!isValidCssColor(backgroundColor)) {
    return false;
  }

  const textColor = getTextColor(backgroundColor);

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  head.appendChild(style);

  const css = `
    body { 
      background-color: ${backgroundColor} !important; 
    }
    div.product-tile {
      border-color: ${backgroundColor} !important;
    }
    .store-message-header {
      color: ${textColor} !important;
    }
    a.merch-footer-link {
      color: ${textColor} !important;
    }
    a.merch-footer-text {
      color: ${textColor} !important;
    }
    .pdp-description-text {
      color: ${textColor} !important;
    }
    .cart-header{
      color: ${textColor} !important;
    }
    .contact-us-link {
      color: ${textColor} !important;
    }
    .breadcrumb-text {
      color: ${textColor} !important;
    }
    .breadcrumb-link {
      color: ${textColor} !important;
    }
  `;
  style.id = BACKGROUND_COLOR_STYLE_ELEMENT_ID;
  style.appendChild(document.createTextNode(css));

  return true;
}
